import React from 'react';
import classes from './sideJobCard.module.scss';

function ApplyButton({ label, onClick, disabled }) {
  return (
    <div
      data-testid="apply-button"
      className={`${classes.job_apply} ${classes.job_button} ${disabled && classes.job_apply_disabled}`}
      aria-hidden="true"
      onClick={onClick}
    >
      {label}
    </div>
  );
}

export default ApplyButton;
